module.exports = __webpack_public_path__ + "static/media/filled_bar_shotStrip_tall.fe3fe80b.svg";